//medidad Banner 650x360px
export const ultimasNoticias = [
  {
        "imagen" :"../assets/imgs/Convocatorias/2026/Celebrando la Danza en los Centros Culturales Regionales.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/10.-Celebrando la Danza en los CCRs.pdf",
        "titulo" : "Convocatoria Celebrando la Danza en los Centros Culturales Regionales",
        "fecha" : "del 25 de marzo al 10 de abril del 2026"
    },
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Celebrando la Danza en Hidalgo.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/9.-Convocatoria celebrando la danza .pdf",
        "titulo" : "Convocatoria Celebrando la Danza en Hidalgo",
        "fecha" : "del 25 de marzo al 10 de abril del 2026"
    },
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Encuentro Estatal de Danza.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/8.-Encuentro Estatal de Danza Contemporanea.pdf",
        "titulo" : "Convocatoria Encuentro Estatal de Danza Contemporánea",
        "fecha" : "del 25 de marzo al 10 de abril del 2026"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Alas y Raices 2026.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/7.-convocatoria Alas y Raices 2026.pdf",
        "titulo" : "Convocatoria Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2026",
        "fecha" : "del 18 de marzo al 31 de marzo del 2026"
    },
]